import * as React from 'react';
import {ReactNode, useState} from 'react';
import {faAngleDown} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface ToggleSectionProps {
    children: ReactNode;
    title: string;
}

export const ToggleSection = ({children, title}: ToggleSectionProps) => {
    const [shown, setShown] = useState(true);
    return (
        <>
            <div
                className="tw-text-gray-700 tw-font-bold tw-text-[18px] tw-m-4 tw-flex tw-justify-between tw-cursor-pointer tw-items-center"
                onClick={() => {
                    setShown(!shown);
                }}
            >
                {title}{' '}
                <FontAwesomeIcon
                    className="tw-text-gray-700 tw-ml-8"
                    icon={faAngleDown}
                    size="lg"
                    rotation={shown ? 180 : undefined}
                />
            </div>
            <div className="tw-m-4">{shown && children}</div>
        </>
    );
};
